import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {Divider} from "primereact/divider";
import {DynamicForm} from "@xal3xfx/react-utils";
import {validationSchema} from "./validation";
import {CreateAdvancePaymentRequest, UnprocessedBankTransactionResponse} from "../../../lib/types/types";
import useSWR, {mutate} from "swr";
import {formElements} from "./advance-payment-form";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";
import {AdvancePaymentService} from "../../../lib/services/advance-payment-service";
import {useToast} from "../../../lib/hooks/useToast";
import {BankTransactionService} from "../../../lib/services/bank-transaction-service";

interface Props {
    bankTransaction?: UnprocessedBankTransactionResponse;
    onSave?: () => void
}

const CreateAdvancePayment: React.FC<Props> = props => {
    const initialValue: CreateAdvancePaymentRequest = {
        clientId: 0,
        date: new Date(),
        amount: 0
    }

    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const [formData, setFormData] = useState<CreateAdvancePaymentRequest>({...initialValue});
    const [formElementsState, setFormElementsState] = useState(formElements);

    const toastHelpers = useToast();
    const advancePaymentsService = new AdvancePaymentService(f, toastHelpers);
    const bankService = new BankTransactionService(f, toastHelpers);

    const {data: clientOptions} = useSWR<IDropdownOption[], Error>('/clients/dropdown');

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        if (!props.bankTransaction) return;
        setFormData({
            clientId: props.bankTransaction?.clientId ?? 0,
            date: new Date(),
            amount: props.bankTransaction?.remainingAmount ?? 0
        });
    }, [props.bankTransaction]);

    useEffect(() => {
        if (!clientOptions) return;
        const tempFormElements = {...formElementsState};
        tempFormElements.clientId.options = clientOptions;
        setFormElementsState(tempFormElements);
    }, [clientOptions])

    const handleFormReset = () => {
        setFormData({...initialValue});
    }

    const handleCreate = (data: CreateAdvancePaymentRequest) => {
        return new Promise<boolean>((resolve, reject) => {
            if (props.bankTransaction) {
                bankService.createAdvancePayment(props.bankTransaction.id, data).then((resp) => {
                    if (resp) {
                        if(props.onSave) {
                            props.onSave();
                        }
                        mutate('/advance-payments/lazy');
                        resolve(true);
                    }
                })
            } else {
                advancePaymentsService.createAdvancePayment(data).then((resp) => {
                        if (resp) {
                            mutate('/advance-payments/lazy');
                            resolve(true);
                        }
                    }
                );
            }
        })
    }

    const handleUpdate = (data: CreateAdvancePaymentRequest) => {
        return new Promise<boolean>(async (resolve, reject) => {
            //TODO:
            // const updatedClient = await clientService.update(data);
            // setIsUpdate(false);
            // mutate('/clients/dropdown');
            // mutate('/clients/' + updatedClient.id);
            // mutate('/clients/lazy');
            resolve(true);
        })
    }

    const handleCancelUpdate = () => {
        setFormData({...initialValue});
    }

    return <>
        <Divider align={'center'}>
            <h3>{f({id: 'addAdvancePayment'})}</h3>
        </Divider>
        <DynamicForm initialValues={formData} onFormReset={handleFormReset} onCreate={handleCreate}
                     onUpdate={handleUpdate} isUpdate={false} onCancelUpdate={handleCancelUpdate}
                     fieldOrder={['clientId', 'date', 'amount']}
                     validationSchema={validationSchema}
                     formElements={formElementsState}>
        </DynamicForm>
    </>
};

export default CreateAdvancePayment
